<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактировать отзыв</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click="dialog = true">
                    Удалить
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="review_name"
                        v-model="review.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        text
                        solo
                        single-line
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Источник</v-subheader>
                            <v-text-field
                                ref="review_from"
                                v-model="review.from"
                                v-validate="'required'"
                                data-vv-name="from"
                                :error-messages="errors.collect('from')"
                                text
                                solo
                                single-line
                                required/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="review.status ? 'Включен' : 'Отключен'" v-model="review.status"
                                        class="mt-0"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Текст</v-subheader>
                    <v-textarea
                        ref="review_body"
                        v-model="review.body"
                        v-validate="'required|max:191'"
                        data-vv-name="body"
                        :error-messages="errors.collect('body')"
                        text
                        solo
                        single-line
                        required
                        counter="191"/>
                </v-flex>
            </v-form>
            <v-dialog v-model="dialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Отзыв будет удален! <br/> Вы уверены что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="info" class="v-btn--save" @click="deleteReview">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import Review from '../../../api/review'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'editReview',
        $_veeValidate: {
            validator: 'new'
        },
        components: { Loader },
        data: () => ({
            loading: false,
            loader: false,
            review: {
                name: '',
                from: '',
                body: '',
                status: true
            },
            dialog: false,
            waitDelete: false,
            dictionary: {
                custom: {
                    name: {
                        required: 'Имя не введено'
                    },
                    from: {
                        required: 'Источник отзыва не указан'
                    },
                    body: {
                        required: 'Текст не введен',
                        max: 'Превышано максимальное количество символов'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
            this.getReview(this.$route.params.reviewId)
        },
        methods: {
            getReview (id) {
                this.loader = true

                Review
                    .getById(id)
                    .then(response => this.review = response.data.data)
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'reviewRoot' })
                    })
                    .finally(() => this.loader = false)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Review
                            .edit(this.review)
                            .then(response => {
                                this.$store.commit('updateReview', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Отзыв отредактирован',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'reviewRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            deleteReview () {
                this.waitDelete = true

                Review
                    .delete(this.review.id)
                    .then(response => {
                        this.$store.commit('deleteReview', { id: this.review.id })
                        this.$store.commit('showSnackbar', {
                            text: response.data.data,
                            color: 'success'
                        })
                        this.$router.push({ name: 'reviewRoot' })
                    })
                    .catch(error => new Error(error))
                    .finally(() => {
                        this.dialog = false
                        this.waitDelete = false
                    })
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.review = this.getReview(to.params.reviewId)
            next()
        }
    }
</script>
